import React from 'react';
import * as T from 'prop-types';
import cn from 'classnames';
import cloneDeep from 'lodash.clonedeep';
import { v4 as uuidv4 } from 'uuid';

import AuInput from '@au/core/lib/components/elements/AuInput';
import AuButton, { BUTTON_SIZE_SMALL } from '@au/core/lib/components/elements/AuButton';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';

import { NOOP } from '../constants';

import styles from '../css/components/annotation_tag_filter.module.scss';

export default class AnnotationFilterValue extends React.PureComponent {

  // May contain other properties defined in AuDropDown.propTypes
  static propTypes = {
    value: T.array,
    onChange: T.func
  }

  static defaultProps = {
    value: [],
    onChange: NOOP
  }

  constructor(props) {
    super(props);

    let initialValues = [{ value: '', id: uuidv4() }];
    if (this.props.value && this.props.value.length !== 0) {
      initialValues = this.props.value.map(v => ({ ...v, id: v.id || uuidv4() }));
    }

    this.state = { values: initialValues };
  }

  handleChange(id, event) {
    const val = event.target.value;
    this.setState(prevState => {
      const values = cloneDeep(prevState.values);
      const item = values.find(v => v.id === id);
      if (item) item.value = val;
      return { values };
    }, this.commitChanges);
  }

  handleOnClear(id) {
    this.setState(prevState => {
      const values = cloneDeep(prevState.values);
      const item = values.find(v => v.id === id);
      if (item) item.value = '';
      return { values };
    }, this.commitChanges);
  }

  addValue = () => {
    this.setState(prevState => {
      const values = cloneDeep(prevState.values);
      values.push({ value: '', id: uuidv4() });
      return { values };
    }, this.commitChanges);
  }

  removeValue(id) {
    this.setState(prevState => {
      let values = prevState.values.filter(v => v.id !== id);
      if (values.length === 0) {
        values.push({ value: '', id: uuidv4() });
      }
      return { values };
    }, this.commitChanges);
  }

  commitChanges() {
    const { values } = this.state;
    const validValues = values.filter(v => v.value.length !== 0);
    this.props.onChange(validValues);
  }

  renderValue = (value) => {
    const { hintClassName } = this.props;
    let showHint = value.value.length !== 0 && value.value?.includes(',');
    let showCountryCodeError = false;
    let showMaxLengthError = false;

    if (this.props.COUNTRY_CODE && value.value.length > 2) {
      showCountryCodeError = true;
    } else if (value.value.length > 256) {
      showMaxLengthError = true;
    }

    return (
      <div key={value.id}>
        <div className={cn(styles.input_container, {[styles.no_margin]: showHint, [styles.align_items]: Boolean(value.value.match("\"")) || showCountryCodeError || showMaxLengthError})}>
          <AuInput
            className={cn({[styles.no_margin]: showHint})}
            value={value.value}
            createMode={true}
            onChange={(e) => this.handleChange(value.id, e)}
            onClear={() => this.handleOnClear(value.id)}
            showError={Boolean(value.value.match("\"")) || showCountryCodeError || showMaxLengthError}
            error={{
              errDisplayId: Boolean(value.value.match("\"")) && 'au.validation.invalidFormat' || showCountryCodeError && 'au.validation.maxLength' || showMaxLengthError && 'au.validation.maxLength',
              fieldDisplayId: Boolean(value.value.match("\"")) && 'au.entity.value' || showCountryCodeError && 'au.taps.filter.details.COUNTRY_CODE' || showMaxLengthError && 'au.entity.value',
              values: Boolean(value.value.match("\"")) && {invalidCharacters: `"`} || showCountryCodeError && {length: 2} || showMaxLengthError && {length: 256}
            }}
          />
          <button
            type="button"
            className={cn(styles.delete, { [styles.disabled]: !value.value })}
            onClick={() => this.removeValue(value.id)}
          />
        </div>
        {
          showHint && <div className={styles.hint_container}>
            <AutoIntl displayId={''} className={styles.icon} tag="div" />
            <AutoIntl displayId={'au.annotationFilterValue.hint'} className={hintClassName} />
          </div>
        }
      </div>
    );
  }

  render() {
    return (
      <div className={styles.container}>
        {this.state.values.map(this.renderValue)}
        <AuButton
          displayId="au.addValue"
          className={styles.button}
          size={BUTTON_SIZE_SMALL}
          onClick={this.addValue}
        />
      </div>
    );
  }
}
